import(/* webpackMode: "eager" */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/(auth)/register/page.tsx");
